import { asYen, asText, asShortText, withUnit } from "../components/ChangeSummary";

export const VEHICLE_TYPE_LIST = "/admin/vehicletypelist";

// The eight amenity rows, each an icon and a line of text.
export const AMENITY_SLOTS = [1, 2, 3, 4, 5, 6, 7, 8];

/**
 * Every field the vehicle type forms write, in the order the screens show them, with
 * the label and formatter the change summary lists it under.
 *
 * These are live prices and capacities: a vehicle type saved here is what the customer
 * site quotes on the next search, and the edit form is wide enough that the one number
 * that was actually touched is easy to lose. The confirmation dialog lists nothing but
 * the differences so that number is the only thing the admin has to check.
 */
export const VEHICLE_TYPE_FIELDS = [
  { name: "typename", label: "Type name", format: asText },
  { name: "hourlyprice", label: "30 minutes rate", format: asYen },
  { name: "baseprice", label: "Base price", format: asYen },
  { name: "basepricehours", label: "Base price hours", format: withUnit("hours") },
  {
    name: "hourlypriceOutsideTokyo",
    label: "30 minutes rate, outside Tokyo",
    format: asYen,
  },
  { name: "basepriceOutsideTokyo", label: "Base price, outside Tokyo", format: asYen },
  {
    name: "basepricehoursOutsideTokyo",
    label: "Base price hours, outside Tokyo",
    format: withUnit("hours"),
  },
  { name: "vehicletypeimage", label: "Image name", format: asText },
  { name: "description", label: "Description", format: asShortText() },
  { name: "maxpassenger", label: "Maximum passengers", format: asText },
  { name: "maxluggages", label: "Maximum luggages", format: asText },
  {
    name: "lastAvailibility",
    label: "Last availability",
    format: (value) => (value ? String(value) : "No limit"),
  },
  { name: "subtitle", label: "Sub-title", format: asShortText() },
  ...AMENITY_SLOTS.flatMap((n) => [
    { name: `option${n}Icon`, label: `Option ${n} icon`, format: asText },
    { name: `optionText${n}`, label: `Option ${n} text`, format: asShortText() },
  ]),
];

const byName = (name) => VEHICLE_TYPE_FIELDS.find((field) => field.name === name);

// The create screen asks for the core pricing and capacity only; the amenity rows,
// the outside-Tokyo rates and the availability cut-off are filled in on the edit
// screen once the type exists.
export const ADD_VEHICLE_TYPE_FIELDS = [
  "typename",
  "hourlyprice",
  "baseprice",
  "vehicletypeimage",
  "description",
  "maxpassenger",
  "maxluggages",
].map(byName);
